import { Divider, Flex, HStack, Text } from "@chakra-ui/react";
import { useFormatMoney } from "hooks/use-format-money";
import { StatisticLink } from "modules/vendor-portal/screens/overview/components/price-indication/statistics-link";
import type { PriceIndicationRange } from "modules/vendor-portal/screens/overview/components/price-indication/utils";

type MinimalPriceIndicationProps = {
  priceRange: PriceIndicationRange;
};
export function MinimalPriceIndication({
  priceRange,
}: MinimalPriceIndicationProps) {
  const formatMoney = useFormatMoney();
  return (
    <Flex direction={"column"} gap={5} w={"100%"}>
      <HStack gap={{ base: 2, sm: 4 }} justifyContent={"space-between"}>
        <StatisticLink
          fontSize={{ base: "md", sm: "lg" }}
          fontWeight={700}
          numberFilter={{ lte: priceRange.minValue }}
        >
          {`${formatMoney(priceRange.minValue)}`}
        </StatisticLink>
        <StatisticLink
          fontSize={{ base: "2xl", sm: "5xl" }}
          fontWeight={700}
          numberFilter={{ between: [priceRange.minValue, priceRange.maxValue] }}
        >
          {`${formatMoney(priceRange.averageValue)}`}
        </StatisticLink>
        <StatisticLink
          fontSize={{ base: "md", sm: "lg" }}
          fontWeight={700}
          numberFilter={{ gte: priceRange.maxValue }}
        >
          {`${formatMoney(priceRange.maxValue)}`}
        </StatisticLink>
      </HStack>

      <HStack gap={{ base: 2, sm: 4 }} justifyContent={"space-between"}>
        <Text fontSize={"lg"} color={"gray.600"}>
          Lowest
        </Text>
        <Divider borderColor={"#2D3748"} />
        <Text fontSize={"lg"} color={"gray.600"} fontWeight={600}>
          Average
        </Text>
        <Divider borderColor={"#2D3748"} />
        <Text fontSize={"lg"} color={"gray.600"}>
          Highest
        </Text>
      </HStack>
    </Flex>
  );
}
